import * as ActionTypes from './ActionTypes';
import InitialState from '../InitialState';
import assign from 'object-assign';
import IFeatureState from '../../../../store/IFeatureState';
import * as OrderActionTypes from '../ActionTypes';

export default function viewOrderReducer(
    state: any = InitialState.viewOrder.contactAddress,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.CONTACT_ADDRESS_SUCCESS: {
            const newState = assign({}, state);
            newState.orderContactAddress = assign({}, action.result);
            return newState;
        }

        case ActionTypes.UPDATE_ORDER_ADDRESS_SUCCESS: {
            const newState = assign({}, state);
            newState.orderContactAddress = assign({}, state.orderContactAddress);
            action.result.availableCommercialObjectTypes =
                state.orderContactAddress.availableCommercialObjectTypes;
            action.result.availableContactPersons =
                state.orderContactAddress.availableContactPersons;
            action.result.availablePrivateObjectTypes =
                state.orderContactAddress.availablePrivateObjectTypes;
            newState.orderContactAddress.orderAddress = assign({}, action.result);
            return newState;
        }

        case ActionTypes.UPDATE_ORDER_OWNER_SUCCESS: {
            const newState = assign({}, state);
            newState.orderContactAddress = assign({}, state.orderContactAddress);
            action.result.availableCommercialObjectTypes =
                state.orderContactAddress.availableCommercialObjectTypes;
            action.result.availableContactPersons =
                state.orderContactAddress.availableContactPersons;
            action.result.availablePrivateObjectTypes =
                state.orderContactAddress.availablePrivateObjectTypes;
            newState.orderContactAddress.orderOwner = assign({}, action.result);
            return newState;
        }

        case OrderActionTypes.RESET_ORDER_STATES:
            return InitialState.viewOrder.contactAddress;

        default:
            return state;
    }
}
